import { render, staticRenderFns } from "./RepairExtensions.vue?vue&type=template&id=25ad5146"
import script from "./RepairExtensions.vue?vue&type=script&lang=js"
export * from "./RepairExtensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports